(function (angular, undefined) {
    'use strict';
    angular.module('blocks.filters', []);

})(angular);
